// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"4px","resultstablecontainer":"series-results-page__resultstablecontainer____ZjHI4","droppedscore":"series-results-page__droppedscore____vI2JL"};